import {call, put, takeLatest, fork, all, delay} from 'redux-saga/effects';
import * as Types from '../constants/Types';
import * as RoomTypeService from './../services/roomTypeService';
import i18n from '../constants/initLng';
import * as Func from "../helpers/functions";
import {message} from 'antd'
import { setListRoomTypes as setListRoomTypesAction, setRoomType as setRoomTypeAction, saveRoomTypeSuccess, setAllRoomTypesByHotel } from './../actions/roomTypeAction';
import {PATHS} from "./../constants/Define";
import {SAGA_DELAY_TIMEOUT} from '../constants/Define';
import { omit } from 'lodash';
import history from '../helpers/history';
import { roomTypeAutoTranslate } from 'services/autoTranslateService';
import { roomTypeAutoTranslateRequest } from 'actions/autoTranslateAction';

function* setListRoomTypeSaga() {
    yield takeLatest(Types.ROOM_TYPE_LIST_ACTION, Func.sagaWrapper(function* (action) {
        const limit = action.filters.pageSize ? action.filters.pageSize : undefined;
        const offset = action.filters.pageIndex ? (action.filters.pageIndex - 1) * limit : undefined;
        const hotel_id = action.filters.hotelId || undefined;
        const params = {
            ...omit(action.filters, ['pageIndex', 'pageSize']),
            limit, offset,hotel_id, 
        }
        yield delay(SAGA_DELAY_TIMEOUT);
        const result = yield call(RoomTypeService.getRoomTypes, params);
        yield put(setListRoomTypesAction(result));
    }, errorHandleRoomType(Types.ROOM_TYPE_LIST_FAIL)))
}

// TRANSLATE
function* createRoomTypeTranslate() {
    yield takeLatest(Types.ROOM_TYPE_CREATE_TRANSLATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(RoomTypeService.createRoomTypeTranslate, action.roomType);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.201'), action.roomType.translate.languageName);
        yield put({ type: Types.ROOM_TYPE_CREATE_TRANSLATE_SUCCESS });
        yield put({ type: Types.ROOM_TYPE_DETAIL_ACTION, id: action.roomType.id });
    }, errorHandleRoomType(Types.ROOM_TYPE_FAIL)))
}

function* updateRoomTypeTranslate() {
    yield takeLatest(Types.ROOM_TYPE_UPDATE_TRANSLATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(RoomTypeService.updateRoomTypeTranslate, action.roomType);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.204'), action.roomType.translate.languageName);
        yield put({ type: Types.ROOM_TYPE_UPDATE_TRANSLATE_SUCCESS });
        yield put({ type: Types.ROOM_TYPE_DETAIL_ACTION, id: action.roomType.id });
    }, errorHandleRoomType(Types.ROOM_TYPE_FAIL)))
}

function* deleteRoomTypeTranslate() {
    yield takeLatest(Types.ROOM_TYPE_DELETE_TRANSLATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(RoomTypeService.deleteRoomTypeTranslate, action.roomType.translate.id);
        Func.sagaSuccessMessage(action, i18n.t('notification.removeSuccess'), action.roomType.translate.languageName);
        yield put({ type: Types.ROOM_TYPE_DELETE_TRANSLATE_SUCCESS });
        yield put({ type: Types.ROOM_TYPE_DETAIL_ACTION, id: action.roomType.id });
    }, errorHandleRoomType(Types.ROOM_TYPE_FAIL)))
}

function errorHandleRoomType(errorActionType) {
    return Func.sagaErrorHandler(function* (e) {
        yield put({ type: errorActionType })
    }, 'roomType');
}

function* setRoomTypeSaga() {
    yield takeLatest(Types.ROOM_TYPE_DETAIL_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(RoomTypeService.getRoomType, action.id);
        yield put(setRoomTypeAction(result));
    }, errorHandleRoomType(Types.ROOM_TYPE_DETAIL_FAIL)))
}

function* saveRoomTypeSaga() {
    yield takeLatest(Types.ROOM_TYPE_SAVE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(RoomTypeService.saveRoomType, action.roomType);
        if (action.roomType.targetLanguage && action.roomType.targetLanguage.length > 0) {
        yield put(roomTypeAutoTranslateRequest({
            sourceId: action.roomType?.id,
            sourceLanguage: 'vi-VN',
            targetLanguages: action.roomType?.targetLanguage,
            callbacks: action?.callbacks
        }));
        }
        message.success(i18n.t(`validation.statusCode.code.${action.roomType.id ? '204':'201'}`));
        yield put({ type: Types.ROOM_TYPE_DETAIL_ACTION, id: action.roomType.id });
        // history.push(PATHS.ROOM_TYPE.LIST.path.replace(':hotel_id',  action.roomType.hotelId));
        // history.go();
    }, errorHandleRoomType(Types.ROOM_TYPE_SAVE_FAIL)))
}

function* setListRoomTypeByHotelSaga() {
    yield takeLatest(Types.ROOM_TYPE_ALL_HOTEL_ACTION, Func.sagaWrapper(function* (action) {
        yield delay(SAGA_DELAY_TIMEOUT);
        const result = yield call(RoomTypeService.getRoomTypeAllByHotel, action.id);
        yield put(setAllRoomTypesByHotel(result.data || []));
    }, errorHandleRoomType(Types.ROOM_TYPE_LIST_FAIL)))
}

function* createRoomType () {
    yield takeLatest(Types.ROOM_TYPE_CREATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(RoomTypeService.createRoomType, action.roomType);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.201'));
        yield put({ type: Types.ROOM_TYPE_CREATE_SUCCESS });
        history.push(PATHS.ROOM_TYPE.LIST.path.replace(':hotel_id', action.roomType.roomtype.hotelId));
        history.go();
    }, errorHandleRoomType(Types.ROOM_TYPE_LIST_FAIL)))
}

export function* roomTypeSaga() {
    yield all([
        fork(setListRoomTypeSaga),
        fork(setRoomTypeSaga),
        fork(saveRoomTypeSaga),
        fork(createRoomType),
        fork(createRoomTypeTranslate),
        fork(updateRoomTypeTranslate),
        fork(deleteRoomTypeTranslate),
        fork(setListRoomTypeByHotelSaga),
    ])
}
